import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { FirebaseFunctionsService } from 'src/app/services/firebase-functions.service';

@Component({
  selector: 'app-classe',
  templateUrl: './classe.component.html',
  styleUrls: ['./classe.component.scss']
})
export class ClasseComponent implements OnInit, OnDestroy {

  classeId: string = '';
  classeName: string = 'Classe';
  classeLevels: string = '';
  classeData: Observable<any>;
  classeSegment: string = 'infos';
  classeStars: number = 0;
  classResp: string = '';
  classeStudentList: string[];
  userType: any;
  constructor(private activatedRoute: ActivatedRoute,private afs: FirebaseFunctionsService, public app: AppComponent) {
    this.classeId = this.activatedRoute.snapshot.params.cdc;

    const typeUser = sessionStorage.getItem('userType');
    if (typeUser == 'administrateur') {
      this.app.navigateTo('/admin');
    }
  }

  ngOnInit(): void {
    this.getClasseData();
    this.getStudentsList();
    setTimeout(this.app.afficherPage,2000);
    this.reinitializeMenus();
    document.querySelector('.menu_accueil').classList.add('selected');
  }
  ngOnDestroy(){
    this.classeStudentList = null;
  }
  getUserData(){
    const uid = sessionStorage.getItem('userId');
    this.afs.getUtilisateur(uid).forEach( user => {
      this.userType = user['typeUtilisateur'];
    });
  }
  getClasseData(){
    this.classeData = this.afs.getClasseById(this.classeId);
    this.classeData.forEach( data => {
      this.classeName = data.nom;
      this.classeLevels = data.niveau;
      this.classeStars = data.medailles_count;
      this.afs.getUtilisateur(data.responsable_id).forEach( user => {
        this.classResp = user['prenom'] + ' ' + user['nom'];
      });
    });
  }
  getStudentsList(){
    const uid = sessionStorage.getItem('userId');
    let forLoop = 0;
    this.classeStudentList = [];
    this.afs.getClasseById(this.classeId).subscribe( data => {
      if(forLoop == 0){
        const classeIds = data['eleves_id'];
        classeIds.forEach(id => {
          let forLoop2 = 0;
          this.afs.getUtilisateur(id).forEach( student => {
            if(forLoop2 == 0){
              if(uid == student['userId']){
                this.classeStudentList.push('moi');
              }else{
                this.classeStudentList.push(student['prenom'] + ' ' + student['nom'])
              }
              forLoop2++;
            }

          });
        });
        forLoop++;
      }
    })
  }
  reinitializeMenus(){
    const menusTabs = document.querySelectorAll('.menus_tab');
    menusTabs.forEach( tabs => {
      (tabs as HTMLElement).classList.remove('selected');
    })
  }

}
